import "core-js/stable";
import Vue from "vue";
import App from "./App";
import router from "./router";
import CoreuiVue from "@coreui/vue";
import { iconsSet as icons } from "./assets/icons/icons.js";
import store from "@/stores";
import VueResource from "vue-resource";
import VeeValidate from "vee-validate";
import customTimingMessage from "./validation";

import VueLazyLoad from "vue-lazyload";
import ShareNetwork from "vue-social-sharing";
import vuetify from "@/plugins/vuetify";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import ElementUI from "element-ui";
import { ElementTiptapPlugin } from "element-tiptap";
import "element-ui/lib/theme-chalk/index.css";
import "element-tiptap/lib/index.css";

Vue.use(ElementUI);
Vue.use(ElementTiptapPlugin, {
  lang: "en",
});

Vue.use(VueLazyLoad);
Vue.use(ShareNetwork);
Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.prototype.$log = console.log.bind(console);
Vue.use(VueResource);
Vue.use(VueSweetalert2);
Vue.transport = require("./transport").default;
Vue.transport.init();
VeeValidate.use(({ ErrorBag }) => {
  const msg = customTimingMessage(ErrorBag);
  return msg;
});
import Swal from "sweetalert2";
Vue.http.interceptors.push((request, next) => {
  function openSwalMessage(message) {
    Swal.fire({
      toast: true,
      html: "<p> <b>" + message + "</b></p>",
      showCancelButton: false,
      // cancelButtonText: "<i class='glyphicon glyphicon-remove'></i>",
      showConfirmButton: false,
      position: "bottom",
      // allowOutsideClick: false,
      // imageUrl: "/images/icons/error.png",
      // imageWidth: 50,
      // imageHeight: 55,
      customClass: "bottom-swal",
      timer: 6000,
    });
  }
  next((response) => {
    if (response.status == 401) {
      openSwalMessage(response.body.message);
      localStorage.clear(); // TODO: it should be in common method.
      router.push({
        name: "Login",
      });
      Vue.$transport.close();
    } else if (
      (response.status != 200 &&
        response.status != 201 &&
        response.status != 0) ||
      response.body.status == false
    ) {
      if (request.snackbarStatus != true) {
        let message =
          response.body.message ||
          "There is some internal Error Please try after some time";
        openSwalMessage(message);
      }
    }
    // store.commit("general/hideLoading");
  });
});

Vue.use(
  VeeValidate,
  {
    inject: false,
  },
  {
    events: "change|blur|input",
  }
);

Vue.http.interceptors.push((request, next) => {
  if (localStorage.token) {
    request.headers.set("Authorization", `Bearer ${localStorage.token}`);
  }
  request.headers.set("Accept", "application/json");
});

export const bus = new Vue();

new Vue({
  el: "#app",
  router,
  store,
  icons,
  template: "<App/>",
  vuetify,

  components: {
    App,
  },
});
